(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tsc-quote-form"]) return;
  try {
    
const tscQuoteParameters = new URLSearchParams(window.location.search);
const tscQuoteItems = document.getElementById('TscQuoteItems');
if (tscQuoteItems && tscQuoteParameters.has('product')) {
 tscQuoteItems.value = ['product', 'variant', 'sku'].map(key => tscQuoteParameters.get(key)).filter(value => value && value !== 'Default Title').join(' | ');
 const quantity = Number(tscQuoteParameters.get('quantity'));
 const quantityInput = document.getElementById('TscQuoteQuantity');
 if (quantityInput && Number.isSafeInteger(quantity) && quantity > 0) quantityInput.value = quantity;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsc-technical-center"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-technical-center]');
  roots.forEach((root) => {
    const search = root.querySelector('[data-tc-search]');
    const category = root.querySelector('[data-tc-category]');
    const topics = Array.from(root.querySelectorAll('[data-topic]'));
    const results = root.querySelector('[data-tc-results]');
    const empty = root.querySelector('[data-tc-empty]');
    const normalize = (value) => value.toLocaleLowerCase('he').trim();
    const update = () => {
      const query = normalize(search.value);
      const selected = category.value;
      let visible = 0;
      topics.forEach((topic) => {
        const categoryMatch = !selected || topic.dataset.category === selected;
        const topicMatch = !query || normalize(topic.dataset.search).includes(query);
        let rowMatch = false;
        topic.querySelectorAll('[data-tsc-row]').forEach((row) => {
          const match = !query || topicMatch || normalize(row.dataset.search).includes(query);
          row.hidden = query && !match;
          rowMatch = rowMatch || match;
        });
        const show = categoryMatch && (topicMatch || rowMatch);
        topic.hidden = !show;
        if (show) { visible += 1; if (query) topic.open = true; }
      });
      results.textContent = `מציג ${visible} מתוך ${topics.length} נושאים`;
      empty.hidden = visible !== 0;
    };
    search.addEventListener('input', update);
    category.addEventListener('change', update);
    const wrench = root.querySelector('[data-wrench-size]');
    if (wrench) {
      const renderWrench = () => {
        const option = wrench.options[wrench.selectedIndex];
        root.querySelector('[data-wrench-iso]').textContent = option.dataset.iso === "לא מוצג" ? "לא מוצג" : `${option.dataset.iso} מ״מ`;
        root.querySelector('[data-wrench-din]').textContent = `${option.dataset.din} מ״מ`;
      };
      wrench.addEventListener('change', renderWrench);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
